import { Directive, forwardRef, Input, OnInit } from '@angular/core';
import { FormControl, NG_VALIDATORS } from '@angular/forms';
import { min, max, range, rangeLength, decimal } from './axis-custom-validators';

const INPUT_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => AxisValidateDirective),
  multi: true
};
export interface InputSettings {
  prefix?: string;
  decimal_separator?: string;
  thousands_separator?: string;
  suffix?: string;
  fraction_size?: number;
  max?: number;
  maxValue?: number;
  min?: number;
  decimal: number;
  reg_exp?: any;
}

@Directive({
  selector:
    '[axis-validate], [axis-validate][ngModel],[axis-validate][formControl]',
  providers: [INPUT_VALIDATOR]
})
export class AxisValidateDirective implements OnInit {
  protected defaultSettings: any = {
    prefix: '',
    decimal_separator: '.',
    thousands_separator: '',
    suffix: '',
    fraction_size: null,
    maxValue: '',
    min: '',
    decimal: '',
    reg_exp: ''
  };
  @Input('axisInputNumber') settings: InputSettings;
  validators: Array<Function> = [];

  constructor() {}

  ngOnInit() {
    if (this.settings) {
      this.settings.maxValue =
        this.settings.maxValue ? this.settings.maxValue
          : this.defaultSettings.maxValue;
      this.settings.min =
        this.settings.min || this.settings.fraction_size === 0
          ? this.settings.min
          : this.defaultSettings.min;
      this.settings.decimal =
        this.settings.decimal || this.defaultSettings.decimal;
    } else {
      this.settings = this.defaultSettings;
    }

    if (this.settings['maxValue']) {
      this.validators.push(max(this.settings['maxValue']));
    }
    if (this.settings['min']) {
      this.validators.push(min(this.settings['min']));
    }

    if (this.settings['range']) {
      this.validators.push( range(this.settings['range']));
    }
    if (this.settings['rangeLength']) {
      this.validators.push( rangeLength(this.settings['rangeLength']));
    }
    if (this.settings['decimal']) {
      this.validators.push( decimal(this.settings['decimal']));
    }
  }
  validate(c: FormControl) {
    let error: any;
    if (this.validators.length) {
      for (let index = 0; index < this.validators.length; index++)  {
        error = this.validators[index](c);
        if (error) {
          break;
        }
      }
    }
    return error;
  }
}
